import type { CampaignMetrics } from "../../../../shared/types/campaign-card.type";
import {
	fmtDec,
	fmtMoney,
	fmtNum,
	fmtRoiPct,
	placementColor,
	signedMetricModifier,
} from "../../../../shared/utils/campaign-metrics-format";

type Props = {
	context: string;
	placementName: string;
	metrics: CampaignMetrics;
	sharePct?: number;
};

export const PlacementMetricsTooltip = ({
	context,
	placementName,
	metrics,
	sharePct,
}: Props) => {
	const color = placementColor(placementName);

	return (
		<div className='campaign-detail__flow-tooltip' role='tooltip'>
			<div className='campaign-detail__flow-tooltip-head'>
				<span
					className='campaign-detail__flow-tooltip-dot'
					style={{ background: color }}
				/>
				<span className='campaign-detail__flow-tooltip-title'>
					{context} · {placementName}
				</span>
				{sharePct != null && (
					<span className='campaign-detail__flow-tooltip-pct'>
						{fmtDec(sharePct, 1)}%
					</span>
				)}
			</div>
			<div className='campaign-detail__flow-tooltip-metrics'>
				<MetricRow label='Cost' value={fmtMoney(metrics.cost)} />
				<MetricRow label='Impressions' value={fmtNum(metrics.impr)} />
				<MetricRow label='Installs' value={fmtNum(metrics.inst)} />
				<MetricRow label='Registrations' value={fmtNum(metrics.reg)} />
				<MetricRow label='Revenue' value={fmtNum(metrics.dep)} />
				<MetricRow label='Revenue $' value={fmtMoney(metrics.dep_sum)} />
				<MetricRow
					label='Profit'
					value={fmtMoney(metrics.profit)}
					accent={signedMetricModifier(metrics.profit)}
				/>
				<MetricRow
					label='ROI'
					value={metrics.roi != null ? fmtRoiPct(metrics.roi) : "—"}
					accent={
						metrics.roi != null
							? signedMetricModifier(metrics.roi)
							: undefined
					}
				/>
			</div>
		</div>
	);
};

function MetricRow({
	label,
	value,
	accent,
}: {
	label: string;
	value: string;
	accent?: string;
}) {
	return (
		<div className='campaign-detail__flow-tooltip-row'>
			<span className='campaign-detail__flow-tooltip-label'>{label}</span>
			<span
				className={`campaign-detail__flow-tooltip-value${accent ? ` ${accent}` : ""}`}>
				{value}
			</span>
		</div>
	);
}
